import { action } from 'typesafe-actions';
import { KpiSATypes, IKpi } from './types';

export const loadRequest = (
  cd: number,
  inscricao: number[],
  dataInicial: string,
  card: string,
  agrupar: number
) =>
  action(KpiSATypes.LOAD_REQUEST, {
    cd,
    dataInicial,
    agrupar,
    card,
    inscricao,
  });

export const loadSuccess = (data: IKpi[]) => action(KpiSATypes.LOAD_SUCCESS, { data });

export const loadFailure = () => action(KpiSATypes.LOAD_FAILURE, {});
